import { render, staticRenderFns } from "./OverlaysLibraryWindow.vue?vue&type=template&id=cd8b2a60&scoped=true&"
import script from "./OverlaysLibraryWindow.vue?vue&type=script&lang=ts&"
export * from "./OverlaysLibraryWindow.vue?vue&type=script&lang=ts&"
import style0 from "./OverlaysLibraryWindow.vue?vue&type=style&index=0&id=cd8b2a60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8b2a60",
  null
  
)

export default component.exports